import { WlProfilesToolbarEventTypeEnum } from './toolbar-profiles-broadcast-event-type.enum';

/**
 * event emitted by toolbar
 */
export class WlProfilesToolbarEvent {
  public constructor(public type: WlProfilesToolbarEventTypeEnum = null, public data: any = null) {}
}
